import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button } from "reactstrap"
import {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Modal,
	ModalFooter,
	ModalHeader,
	ModalBody,
	UncontrolledButtonDropdown,
} from "reactstrap"
import styles from "../EventButton.module.scss"
import { pinSwitchPlayers } from "../../../../../redux/actions/actions"
import { sendEvent } from "../../../../../api/socket/functions"

function SwitchButton(params) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<div>
			<Button.Ripple color="warning" size="lg" onClick={() => setIsOpen(true)}>
				Zamjena
			</Button.Ripple>
			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered modal-sm"
			>
				<ModalContent {...params} dismissParent={() => setIsOpen(false)} />
			</Modal>
		</div>
	)
}

export default SwitchButton

// This may sound like a very weird thing to do, but I only now realised that
// if i do it this way, the data underneath only loads when it needs to
function ModalContent({ player, dismissModal, teamName, dismissParent }) {
	const dispatch = useDispatch()

	const [selectedPlayer, setSelectedPlayer] = useState(player)
	const [followupPlayer, setFollowupPlayer] = useState({})

	const players =
		JSON.parse(localStorage.getItem("homeTeam")).name == teamName
			? JSON.parse(localStorage.getItem("homeTeam")).players
			: JSON.parse(localStorage.getItem("awayTeam")).players

	const onDone = () => {
		const params = {
			team: teamName,
			event: "Zamjena",
			comment: `(${selectedPlayer.tshirtNumber}) ${selectedPlayer.name} ${selectedPlayer.surname} ide na klupu. Na njegovo mjesto ide (${followupPlayer.tshirtNumber}) ${followupPlayer.name} ${followupPlayer.surname}.`,
			eventKey: "switch",
			playerId: selectedPlayer.playerId,
			tshirtNumber: selectedPlayer.tshirtNumber,
			player2Id: followupPlayer.playerId,
			tshirtNumber2: followupPlayer.tshirtNumber,
		}
		sendEvent(params)
		const isAwayTeam =
			teamName === JSON.parse(localStorage.getItem("awayTeam")).name
		dispatch(
			pinSwitchPlayers(
				selectedPlayer.playerId,
				followupPlayer.playerId,
				isAwayTeam
			)
		)
		onDismiss()
		dismissModal()
	}

	const onDismiss = () => {
		dismissParent()
		setFollowupPlayer({})
	}

	const createDropdown = (dropdownSelectedPlayer, setter, isFirstDropdown) => {
		return (
			<UncontrolledButtonDropdown size="md">
				<DropdownToggle
					color="primary"
					caret
					outline={!dropdownSelectedPlayer.name}
				>
					{dropdownSelectedPlayer.name
						? `(${dropdownSelectedPlayer.tshirtNumber}) ${dropdownSelectedPlayer.name} ${dropdownSelectedPlayer.surname}`
						: "Izaberi igrača"}
				</DropdownToggle>
				<DropdownMenu>
					{players
						.filter(
							(player) =>
								player.playerId !== selectedPlayer.playerId &&
								player.playerId !== followupPlayer.playerId
						)
						.map((player, index) => (
							<DropdownItem
								key={`option-${isFirstDropdown}-${index}`}
								onClick={() => setter(player)}
							>
								{`(${player.tshirtNumber}) ${player.name} ${player.surname}`}
							</DropdownItem>
						))}
				</DropdownMenu>
			</UncontrolledButtonDropdown>
		)
	}

	return (
		<>
			<ModalHeader toggle={onDismiss}>Zamjena</ModalHeader>
			<ModalBody className={`${styles.modalBody} ${styles.switchModal}`}>
				<p>Zamjeni</p>
				{createDropdown(selectedPlayer, setSelectedPlayer, true)}
				<p>Sa</p>
				{createDropdown(followupPlayer, setFollowupPlayer)}
			</ModalBody>
			<ModalFooter>
				{followupPlayer.name && (
					<Button color="primary" onClick={onDone}>
						Spremi
					</Button>
				)}
				<Button color="secondary" onClick={onDismiss}>
					Odustani
				</Button>
			</ModalFooter>
		</>
	)
}
